<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <div class="intro-text">
    <p>
      Des contrats d'assurance des biens pour particuliers pour protéger <strong>tout ce que vous possédez</strong>, notamment
      vos véhicules, votre habitation, tout ce qu'il y a dedans (électroménager, informatique, objets de valeurs,
      bijoux, art), vos travaux de construction et l'immobilier en général en France.
    </p>
  </div>

  <div class="insurance-grid">
    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-home"></i>
      </div>
      <h3>Multirisque Habitation</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Auto Personnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Moto Personnelle</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Auto Temporaire</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-building"></i>
      </div>
      <h3>Multirisque Immeuble - PNO</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-file"></i>
      </div>
      <h3>Garantie Loyers Impayés</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-shield"></i>
      </div>
      <h3>Protection Juridique</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-image"></i>
      </div>
      <h3>Œuvre d'Art Bijoux</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-home"></i>
      </div>
      <h3>Dommages Ouvrage</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-shield"></i>
      </div>
      <h3>Assurance Chiens - Chats - Animaux</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-car"></i>
      </div>
      <h3>Vélo - Trottinette Électrique</h3>
    </div>

    <div class="insurance-card">
      <div class="icon-wrapper">
        <i class="pi pi-question-circle"></i>
      </div>
      <h3>Je ne sais pas quel produit il me faut</h3>
    </div>
  </div>

  <div class="important-section">
    <h2>Très Important :</h2>
    <p>
      L'assurance des biens pour particuliers correspond aux dommages aux biens des particuliers. Vous assurez tout ce qui touche les biens que vous possédez à titre personnel. Donc si vous souhaitez assurer correctement ce que vous possédez alors il vous faudra :
    </p>
    
    <ol>
      <li>Assurer vos biens immobiliers (Incendie, dégâts de eaux, vol, vandalisme de votre appartement, votre maison, vos investissements locatifs) via une <a href="#" class="highlight-link">assurance Multirisque Habitation</a> ou une <a href="#" class="highlight-link">assurance Multirisque Immeuble – MRI – PNO</a></li>
      
      <li>Et assurer vos véhicules (Assurance au tiers, assurance tout risque, RC circulation sur vos véhicules personnels comme l'auto, la moto, le scooter) via une <a href="#" class="highlight-link">assurance Auto Personnelle</a> ou une <a href="#" class="highlight-link">assurance Moto Personnelle</a> ou une <a href="#" class="highlight-link">assurance Auto Temporaire</a> ou une <a href="#" class="highlight-link">assurance Flotte Auto Professionnelle</a> et enfin une <a href="#" class="highlight-link">assurance Trottinette Électrique</a></li>
      
      <li>Mais également couvrir le risque de construction (Travaux de rénovation, tout risque chantier, construction de maison individuelle) via une <a href="#" class="highlight-link">assurance Dommages Ouvrage</a></li>
      
      <li>Et pourquoi pas couvrir le risque (Carence du locataire (loyer non payé, dégradation de votre bien immobilier locatif, non-paiement du reliquat de charges, contentieux judiciaire)) via une <a href="#" class="highlight-link">assurance Loyers Impayés</a></li>
      
      <li>Et enfin protéger vos objets de valeurs (assurance bijoux, assurance oeuvre d'art, assurance tableaux, objets d'art, les meubles et les colliers) via une <a href="#" class="highlight-link">assurance Œuvres d'art-Bijoux</a></li>
      
      <li>Assurer vos animaux domestiques (Chiens, Chats, équidés, honoraires vétérinaire, castration) via une <a href="#" class="highlight-link">assurance Chiens Chats Animaux</a></li>
    </ol>

    <p class="partners-note">
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est listé ci-après : <strong>GENERALI, APRIL, AXA SPVIE, SWISSLIFE, FMA, ENTORIA, PROGEAS, EURODOMMAGES, HELVETIA, XENASSUR, MUTUELLE DU MOTARD, AMV, ZEPHIR, SOLLY AZAR</strong>.
    </p>
  </div>

</app-page-layout>
